export default __webpack_public_path__ + "static/media/Check_green_icon.727207fb.svg";